import { Component, Input, OnInit } from '@angular/core'
import { NaturalStoneLot } from '../../../interfaces/natural-stone/natural-stone-lots'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { environment } from '../../../../environments/environment'
import { DecimalPipe, NgClass, NgIf, NgOptimizedImage } from '@angular/common'
import { ApiService } from '../../../services/api.service'
import { TranslateModule } from '@ngx-translate/core'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { ActivatedRoute, Router } from '@angular/router'
import { NumberStepperComponent } from '@components/number-stepper/number-stepper.component'
import { ButtonComponent } from '@components/button/button.component'
import { NaturalStoneColorService } from '../../../services/natural-stone-color.service'

@Component({
    selector: 'app-natural-stone-lot-card',
    standalone: true,
    imports: [
        NgOptimizedImage,
        NgIf,
        TranslateModule,
        DecimalPipe,
        NumberStepperComponent,
        ButtonComponent,
        NgClass
    ],
    templateUrl: './natural-stone-lot-card.component.html',
    styleUrl: './natural-stone-lot-card.component.scss'
})
export class NaturalStoneLotCardComponent implements OnInit {
    @Input() lot!: NaturalStoneLot
    @Input() index!: number;
    @Input() thickness!: string
    @Input() finish!: string

    finishLabel?: string;

    imageUrl: SafeUrl
    currentImageUrl: string;
    isUsa = false

    qtyToAddToCart: number = 1;

    hasImagesToShow: boolean = true;

    constructor(
        private sanitizer: DomSanitizer,
        private api: ApiService,
        private naturalStoneService: NaturalStoneService,
        private colorService: NaturalStoneColorService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit() {
        this.isUsa = this.api.isUsaUser()
        if (this.lot.lotId) {
            let imageUrl = environment.lotImageCdn.replace('{lotId}', this.lot.lotId)
            this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(imageUrl) //NOSONAR
        }

        this.getFinish()
    }

    getThickness() {
        return this.colorService.getThickness(this.thickness)
    }

    getFinish() {
        this.colorService.getFinish(this.finish).then(finishLabel => {
            this.finishLabel = finishLabel
        })
    }

    getWidth() {
        return this.colorService.getWidth(this.lot)
    }

    getHeight() {
        return this.colorService.getHeight(this.lot)
    }

    getMeasureUnit() {
        return this.colorService.getMeasureUnit()
    }

    getSurfaceArea() {
        return this.colorService.getSurfaceArea(this.lot)
    }

    getSurfaceAreaMeasure() {
        return this.colorService.getSurfaceAreaMeasure()
    }

    getAvailableSlabs(): number {
        return this.colorService.getAvailableSlabs(this.lot)
    }

    onImageLoadError(ignored: ErrorEvent) {
        this.hasImagesToShow = false
        const color = this.naturalStoneService.selectedColor()
        if(this.currentImageUrl !== color.imageUrl && color.imageUrl?.startsWith('https')) {
            this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(color.imageUrl) //NOSONAR
            this.currentImageUrl = color.imageUrl
        } else {
            this.imageUrl = "assets/images/processing-image.png"
        }
    }

    openImageViewer($event: MouseEvent) {
        if(this.hasImagesToShow){
            this.router.navigate([this.lot.lotId], {relativeTo: this.route})
        }
    }

    qtyToAddToCartChanged(qtyToAddToCart: number) {
        this.qtyToAddToCart = qtyToAddToCart
    }

    addToCart(){
        this.naturalStoneService.addLotToCart(this.lot, this.qtyToAddToCart)
    }

}
